export default "__VITE_ASSET__8ba78d6f__"